import React, { Component } from "react";
import { Alert } from "reactstrap";
import { Redirect } from "react-router-dom";
import SiteForm from "../components/SiteForm";
import BreadCrumbs from "../components/BreadCrumbs";
import Api from "../services/globalBibleApi";

class SitesNew extends Component {
  constructor(props) {
    super(props);
    this.state = { notifications: [] };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(formValues) {
    const newSite = formValues;
    Api.createSite(newSite)
      .then(res => {
        this.setState({ createdSiteId: res.siteId });
      })
      .catch(err => {
        const message = err.response
          ? err.response.data.message
          : "Error saving site";
        this.setState({
          notifications: [{ type: "error", message }]
        });
      });
  }

  render() {
    if (this.state.createdSiteId) {
      return <Redirect to={`/sites/${this.state.createdSiteId}`} />;
    }

    return (
      <div>
        <BreadCrumbs
          title="Create Site"
          paths={[
            { title: "Sites", link: "/sites" },
            { title: "Create Site", link: "/sites/new" }
          ]}
        />
        {this.state.notifications.map(notification => (
          <Alert
            key={notification.messsage}
            color={notification.type === "error" ? "danger" : undefined}
          >
            {notification.message}
          </Alert>
        ))}
        <SiteForm onSubmit={this.handleSubmit} />
      </div>
    );
  }
}

export default SitesNew;
